<script>
  import { beforeUpdate, createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  import Login from "../components/account/login.svelte";
  import ForgotPassword from "../components/account/ForgotPassword.svelte";
  import ForgotUsername from "../components/account/ForgotUsername.svelte";
  import ResetOptions from "../components/account/ResetOptions.svelte";
  import UsernameFound from "../components/account/UsernameFound.svelte";
  import SelectedResetOption from "../components/account/SelectedResetOption.svelte";
  import CreateNewPassword from "../components/account/CreateNewPassword.svelte";
  import AccountRecreatedSuccess from "../components/account/AccountRecreatedSuccess.svelte";
  import PasswordResetSuccess from "../components/account/PasswordResetSuccess.svelte";
  import PasswordChangeSuccess from "../components/account/PasswordChangeSuccess.svelte";
  import RecreateAccount from "../components/account/RecreateAccount.svelte";
  import VerifyIdentity from "../components/account/VerifyIdentity.svelte";
  import { setContext} from 'svelte';
  const signinObj = ({fname:'', lname:'', password:'password', id:'1'});
  setContext('signinKey', signinObj);

  export let step = "login";
  let Route = Login;

  beforeUpdate(() => {
    switch (step) {     
      case "forgotpassword":
        Route = ForgotPassword;
        break;
      case "forgotusername":
        Route = ForgotUsername;
        break;
      case "resetoptions":
        Route = ResetOptions;
        break;
      case "usernamefound":
        Route = UsernameFound;
        break;
      case "selectedresetoption":
        Route = SelectedResetOption;
        break;
      case "createnewpassword":
        Route = CreateNewPassword;
        break;
      case "passwordresetsuccess":
        Route = PasswordResetSuccess;
        break;
      case "accountrecreatedsuccess":
        Route = AccountRecreatedSuccess;
        break;
      case "passwordchangesuccess":
        Route = PasswordChangeSuccess;
        break; 
      case "recreateaccount":
        Route = RecreateAccount;
        break;  
      case "verifyidentity":
        Route = VerifyIdentity;
        break;  
      default:
        Route = Login;
        break;
    }
  });
</script>

<svelte:head>
  <title>Password Change</title>
</svelte:head>

<section class="hero is-fullheight" style="background-color: #407f8a;">
  <div class="hero-body">
    <div class="container">
      <div style="text-align:center;">
        <a class="" href="/">
          <img style="height:40px" src="/eamissions-logo.png" alt="eAdmissions Logo"  title="Go to home page"/>
        </a>
      </div>
      <div class="columns is-centered">
        <div class="column is-7-tablet is-6-desktop is-5-widescreen">
          <!-- <main> -->
            <svelte:component this={Route} on:pageChange={(event)=> dispatch("pageChange",event.detail)} />
          <!-- </main> -->
        </div>
      </div>
    </div>
  </div>
</section>
